export enum UserState {
  JUST_CREATED = 'JUST_CREATED',
  COMPETING = 'COMPETING',
  QUESTION_FAILED = 'QUESTION_FAILED',
  DECISION_TIME = 'DECISION_TIME',
  GIVE_UP = 'GIVE_UP',
  WINNER = 'WINNER',
}
